export const stringsHavePartialMatch = (str1: string, str2: string): boolean => {
  if (!str1 || !str2) return false;

  const lowerStr1 = str1.toLowerCase();
  const lowerStr2 = str2.toLowerCase();

  return lowerStr1.includes(lowerStr2) || lowerStr2.includes(lowerStr1);
};
